const axios = require("axios");
import fullConfig from "../../config";

const Config = fullConfig[process.env.NODE_ENV];

const defaultState = {
  providers: [],
  dataDate: null,
  autocomplete: [],
};
const getters = {
  PROVIDER_LIST: (state) => {
    return state.providers;
  },
  DATA_DATE: (state) => {
    return state.dataDate;
  },
  AUTOCOMPLETE_LIST: (state) => {
    return state.autocomplete;
  },
};
const mutations = {
  SET_PROVIDER_LIST: (state, payload) => {
    state.providers = payload;
  },
  SET_DATA_DATE: (state, payload) => {
    state.dataDate = payload;
  },
  SET_AUTOCOMPLETE_LIST: (state, payload) => {
    state.autocomplete = payload;
  },
};
const actions = {
  FETCH_PROVIDER_LIST: async (context) => {
    const json = await axios.get(`${Config.jsonUrl}${Config.dataFile}`);
    context.commit("SET_PROVIDER_LIST", json.data[0].providerData);
    context.commit("SET_DATA_DATE", json.data[0].runDateTime);
  },
  FETCH_AUTOCOMPLETE_LIST: async (context) => {
    // create this file beforehand to save on computing before the page is operational
    const json = await axios.get(`${Config.jsonUrl}${Config.autocompleteFile}`);
    context.commit("SET_AUTOCOMPLETE_LIST", json.data);
  },
};

export default {
  state: defaultState,
  getters,
  mutations,
  actions,
};
